import {useMutation} from '@tanstack/react-query';
import {type FeedbackPayload} from '@guestapp/sdk';
import {useChekinSDK} from 'context/ChekinSDK';
import {useIsMounted} from 'hooks/common';

type Props = {
  onError?: (error: Error) => void;
  onSuccess?: (data: FeedbackPayload) => void;
};
function useMutateCheckoutFeedback({onError, onSuccess}: Props = {}) {
  const {createCheckoutFeedback} = useChekinSDK();
  const isMounted = useIsMounted();

  const {mutate, status} = useMutation<FeedbackPayload, Error, FeedbackPayload>(
    createCheckoutFeedback,
    {
      onError: error => {
        if (!isMounted.current) {
          return;
        }
        onError?.(error);
      },
      onSuccess,
    },
  );

  return {createCheckoutFeedbackMutation: mutate, status};
}

export {useMutateCheckoutFeedback};
